import React from "react";

const EnergyProduction = () => {
  return (
    <div className="box graph-box">
      <div className="savings-widget-title">Produkcja przez ostatni czas</div>
      <div className="graph-placeholder" style={{ color: "black" }}>
        Funkcja dostępna wkrótce
        {/* <Chart
          legend={lineData.legend}
          series={lineData.series}
          options={lineData.options}
          type="line"
          height="100%"
        /> */}
      </div>
    </div>
  );
};

export default EnergyProduction;
